export const MAX_GENERAT_LEN =1